import { ReactNode } from 'react'
import { ToastProvider } from '@vgw/multibrand-fe-toast'
import { ReactQueryProvider } from './providers/react-query-provider'
import { Tracking } from './tracking'
import { OidcProvider } from '@/features/oidc/oidc'
import { I18nProvider } from '@lingui/react'
// eslint-disable-next-line no-restricted-imports
import { i18n } from '@lingui/core'

export const Providers = ({
  children,
  amplitudeApiKey,
}: {
  children: ReactNode
  amplitudeApiKey: string
}) => (
  <I18nProvider i18n={i18n}>
    <OidcProvider>
      <Tracking apiKey={amplitudeApiKey}>
        <ReactQueryProvider>
          <ToastProvider>{children}</ToastProvider>
        </ReactQueryProvider>
      </Tracking>
    </OidcProvider>
  </I18nProvider>
)
